import React, { useMemo } from "react";
import Popover from "components/common/Popover";
import { keySeparator } from "views/Constants";
import OnClickPopoverValueGroups from "views/components/visualizations/OnClickPopover/OnClickPopoverValueGroups";
const HeatmapOnClickPopover = ({ clickPoint, config, setFieldData }) => {
  const { rowPivotValues, columnPivotValues, metricValue } = useMemo(() => {
    var _a, _b, _c, _d;
    if (!clickPoint || !config) return {};
    const splitXValues = clickPoint.x.split(keySeparator);
    const traceColor = null;
    const metric = config.series.length === 1 ? config.series[0].function : splitXValues.pop();
    const columnValues = splitXValues.filter((value) => value !== metric);
    const columnPivotsToFields = (_b = (_a = config == null ? void 0 : config.columnPivots) == null ? void 0 : _a.flatMap((pivot) => pivot.fields)) != null ? _b : [];
    const rowPivotsToFields = (_d = (_c = config == null ? void 0 : config.rowPivots) == null ? void 0 : _c.flatMap((pivot) => pivot.fields)) != null ? _d : [];
    const splitYValues = `${String(clickPoint.y)}`.split(keySeparator);
    return {
      rowPivotValues: splitYValues.map((value, i) => ({
        value,
        field: rowPivotsToFields[i],
        text: String(value),
        traceColor
      })),
      columnPivotValues: columnValues.map((value, i) => ({
        value,
        field: columnPivotsToFields[i],
        text: String(value),
        traceColor
      })),
      metricValue: {
        value: clickPoint.z,
        field: metric,
        text: String(clickPoint.z),
        traceColor
      }
    };
  }, [clickPoint, config]);
  return clickPoint && /* @__PURE__ */ React.createElement(Popover.Dropdown, { title: String(clickPoint == null ? void 0 : clickPoint.z) }, /* @__PURE__ */ React.createElement(
    OnClickPopoverValueGroups,
    {
      columnPivotValues,
      metricValue,
      rowPivotValues,
      setFieldData,
      config
    }
  ));
};
export default HeatmapOnClickPopover;
